<!-- views/Login.vue -->
<template>
	<div class="login-container">
		<div class="login-con-form">
			<div class="login-img">
				<el-image style="width:150px; height: 150px;border-radius: 50%;" :src="require('../../assets/logo.png')" :lazy='true' alt='专利平台' fit="cover"></el-image>
			</div>
			<el-form ref="form" :model="form" class="login-form" @submit.native.prevent="handleLogin">
				<h2 class="title">请登录</h2>
				<el-form-item prop="account">
					<el-input v-model="form.account" :clearable='true' prefix-icon="el-icon-user" placeholder="用户名"></el-input>
				</el-form-item>
				<el-form-item prop="password">
					<el-input v-model="form.password" :show-password='true' :clearable='true' prefix-icon="el-icon-lock" type="password"
						placeholder="密码"></el-input>
				</el-form-item>
				<div class="login-check">
					<el-checkbox v-model="checked">记住密码</el-checkbox>
				</div>
				<el-button type="primary" native-type="submit" :loading="loading" class="login-btn">
					登录
				</el-button>
				<el-link class="reg-txt" type="primary" @click="gotoreg">注册链接</el-link>
			</el-form>
		</div>
	</div>
</template>

<script>
	import userApi from '@/api/user'
	export default {
		data() {
			return {
				form: {
					account: '',
					password: ''
				},
				loading: false,
				checked:false
			}
		},
		created: function() {
			var info = localStorage.getItem('logininfo');
			if(info){
				this.checked = true;
				this.form = JSON.parse(info);
			}
		},
		methods: {
			gotoreg(){
				this.$router.push('Reg');
			},
			handleLogin() {
				this.$refs.form.validate(valid => {
					if (valid) {
						this.loading = true;
						userApi.login(this.form).then(res=>{
							if(this.checked){
								localStorage.setItem('logininfo', JSON.stringify(this.form))
							}
							this.$store.state.token = res.data.userinfo.token;
							this.$store.state.userinfo = JSON.stringify(res.data.userinfo);
							localStorage.setItem('token', res.data.userinfo.token)
							localStorage.setItem('userinfo', JSON.stringify(res.data.userinfo))
							const redirect = this.$route.query.redirect || '/'
							this.$router.replace(redirect)
						})
						this.loading = false;
					}
				})
			}
		}
	}
</script>

<style scoped>
	.login-container {
		display: flex;
		justify-content: center;
		align-items: center;
		height: 100vh;
		background: linear-gradient(to bottom, #00a0ea 0%, #faf7f8 100%);
		
	}
	
	.login-con-form{
		display: flex;
		background: #fff;
		border-radius: 6px;
		box-shadow: 0 0 10px rgba(0, 0, 0, .1);
	}
	.login-img{
		width: 180px;
		min-height: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	
	.login-form {
		width: 360px;
		padding: 40px;
		background: #fff;
	}

	.title {
		margin-bottom: 30px;
		text-align: left;
		color: #333;
	}
	
	.login-check{
		text-align: left;
	}

	.login-btn {
		width: 100%;
		margin-top: 20px;
	}
	.reg-txt{
		margin-top: 18px;
	}
</style>